<template>
  <div class="toolbar">
    <div class="tool-top">
      <!-- <div class="tool-item">
        <div class="tool-boxs" :class="{'color-box':isHouseOver}">
          <i class="el-icon-house"></i>
          <div>增房</div>
        </div>
        <div class="hover-items" @mouseover="isHouseOver=true" @mouseleave="isHouseOver=false">
          <div class="items-title">房源新增</div>
          <div class="items-item" @click="goCreateHouse('住宅')">住宅</div>
          <div class="items-item" @click="goCreateHouse('商铺')">商铺</div>
          <div class="items-item" @click="goCreateHouse('写字楼')">写字楼</div>
          <div class="items-item" @click="goCreateHouse('商住')">商住</div>
          <div class="items-item" @click="goCreateHouse('别墅')">别墅</div>
          <div class="items-item" @click="goCreateHouse('其他')">其他</div>
        </div>
        <div class="overflow-box"></div>
      </div> -->
      <div class="tool-item" @click="goCreateReservation('客源')">
        <div class="tool-box">
          <!-- <i class="el-icon-user"></i> -->
          <img src="@/assets/image/create-reservation.png" />
          <div>报备</div>
        </div>
        <div class="hover-item">添加报备</div>
      </div>
    </div>
    <div class="tool-bottom">
      <!-- <div class="tool-item" @click="goDataReport">
        <div class="tool-box">
          <i class="el-icon-data-analysis"></i>
          <div>报表</div>
        </div>
        <div class="hover-item">常用报表</div>
      </div> -->
      <!-- <div class="tool-item" @click="toPushMsg" v-if="permissions.WeiXinPushMessage">
        <div class="tool-box">
          <i class="el-icon-message"></i>
          <div>推送</div>
        </div>
        <div class="hover-item weixin">微信消息管理</div>
      </div> -->
      <div class="tool-item" @click.stop="toNeedDealt">
        <div class="tool-box">
          <i class="el-icon-edit-outline"></i>
          <div>待办</div>
        </div>
        <div class="hover-item">待办事项</div>
      </div>
      <div class="tool-item" @click="toMessage">
        <div class="tool-box" :class="{'message':messageNum<10}">
          <el-badge v-if="messageNum>0" :value="messageNum" class="item" type="primary">
            <i class="el-icon-chat-dot-round"></i>
          </el-badge>
          <i v-else class="el-icon-chat-dot-round"></i>
          <div>消息</div>
        </div>
        <div class="hover-item">消息盒子</div>
      </div>
      <div class="tool-item" @click="toFeedback">
        <div class="tool-box">
          <i class="el-icon-news"></i>
          <div>反馈</div>
        </div>
        <div class="hover-item">我要反馈</div>
      </div>
      <div class="tool-item to-top" @click="goTop">
        <i class="el-icon-arrow-up"></i>
        <div>TOP</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageInfo } from "@/http/api/message.js";
import bus from "@/utils/messageBus";
export default {
  data() {
    return {
      permissions: this.$store.getters.permissions,
      isHouseOver: false,
      messageNum: 0,
      isShowWeixin:false
    };
  },
  mounted() {
    this.getMessage();
    this.isShowWeixin=this.$store.getters.permissions.WeiXinPushMessage;
    var that = this;
    bus.$on('rush', function (msg) {
        that.getMessage();
    })
  },
  methods: {
    toMessage() {
      this.$router.push({
        path: `/message`,
      });
    },
    toFeedback() {
      this.$router.push({
        path: `/feedback`,
      });
    },
    toNeedDealt() {
      this.$router.push({
        path: `/need-dealt`,
      });
    },
    toPushMsg(){
      this.$router.push({
        path: `/message-send`,
      });
    },
    getMessage() {
      getMessageInfo().then((res) => {
        if (res && res.result) {
          this.messageNum =
            res.result.estateUnReadCount +
            res.result.systemUnReadCount +
            res.result.reservationUnReadCount;
            this.messageNum =this.messageNum >99?"···":this.messageNum
        }
      });
    },
    goTop() {
      this.$parent.toTop();
    },
    goCreateReservation(v) {
      // if (this.permissions["RocketIdentity.Users.Create"]) {
      this.$router.push({
        path: `/reservation/create`,
      });
      // } else {
      //   let msg = v == "客源" ? "增客" : "增房";
      //   this.$message.warning({
      //     message: `您暂无${msg}权限`,
      //     showClose: true,
      //   });
      // }
    },
    goDataReport() {
      this.$router.push({
        path: `/data/report-management`,
        query: {
          type: "oftenUsed",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  flex-direction: column;
  position: fixed;
  right: 0;
  top: 48px;
  bottom: 0;
  height: calc(100vh - 48px);
  width: 40px;
  z-index: 110;

  .tool-bottom,
  .tool-top {
    margin-top: 44px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .tool-item {
      width: 100%;
      color: #666;
      cursor: pointer;
      font-size: 12px;
      height: 40px;
      position: relative;
      margin-top: 16px;
      transition: all 0.2s;
      -moz-transition: all 0.2s; /* Firefox 4 */
      -webkit-transition: all 0.2s; /* Safari 和 Chrome */
      -o-transition: all 0.2s; /* Opera */

      .tool-boxs,
      .tool-box {
        position: absolute;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 999;
        background-color: #fff;
        ::v-deep .el-badge{
          .el-badge__content.is-fixed{
            right: 11px;
          }
          .el-badge__content{
            padding: 0 3px;
          }
        }
        img {
          width: 18px;
          height: 18px;
        }
      }
      .message{
        ::v-deep .el-badge{
          .el-badge__content.is-fixed{
            right: 11px;
          }
          .el-badge__content{
            padding: 0 6px;
          }
        }
      }

      .color-box {
        color: #fff;
        background-color: $--color-primary;
      }

      .replace-boxs {
        z-index: 888;
      }

      .tool-boxs:hover {
        color: #fff;
        background-color: $--color-primary;
        & + .hover-items {
          right: 40px;
        }
      }

      i {
        font-size: 18px;
      }

      .hover-item {
        align-items: center;
        justify-content: center;
        background: #666;
        color: #fff;
        display: flex;
        font-size: 14px;
        height: 100%;
        position: absolute;
        right: -45px;
        top: 0;
        width: 84px;
        transition: all 0.2s;
        -moz-transition: all 0.2s; /* Firefox 4 */
        -webkit-transition: all 0.2s; /* Safari 和 Chrome */
        -o-transition: all 0.2s; /* Opera */

        &:hover {
          background: #3c3e42;
        }

        &.weixin{
          right: -60px;
          width: 100px;
        }
      }

      .hover-items {
        box-shadow: -1px 1px 4px 0 rgba(0, 0, 0, 0.1);
        font-size: 12px;
        margin: 0;
        position: absolute;
        right: -62px;
        top: 0;
        width: 100px;
        background-color: #fff;
        transition: all 0.2s;
        -moz-transition: all 0.2s; /* Firefox 4 */
        -webkit-transition: all 0.2s; /* Safari 和 Chrome */
        -o-transition: all 0.2s; /* Opera */

        &:hover {
          right: 40px;
        }

        .items-title {
          height: 30px;
          background: #666;
          color: #fff;
          line-height: 30px;
          padding-left: 14px;
        }

        .items-item {
          border-right: 1px solid rgba(149, 149, 149, 0.1);
          color: #333;
          padding-left: 14px;
          height: 22px;
          line-height: 22px;
          &:hover {
            background-color: $--color-primary;
            color: #fff;
          }
        }
      }

      .overflow-box {
        position: absolute;
        top: -5px;
        width: 40px;
        height: 180px;
        background-color: #fff;
        cursor: default;
      }

      &:hover {
        .tool-box {
          background-color: $--color-primary;
          color: #fff;
        }
        .hover-item {
          right: 40px;
        }
      }
    }

    .to-top {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #3c3e42;
        color: #fff;
      }
    }
  }
}
</style>